/**
 * File Services Module
 * Exports all file management services and factory functions
 */
// Service exports
export * from './FileService';
export * from './FolderService';
export * from './MultipartUploadService';
// Service imports for factory
import { FileService } from './FileService';
import { FolderService } from './FolderService';
import { MultipartUploadService } from './MultipartUploadService';
/**
 * Create all file services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all file service instances
 */
export function createFileServices(http, config) {
    return {
        file: new FileService(http, config),
        folder: new FolderService(http, config),
        multipartUpload: new MultipartUploadService(http, config),
    };
}
//# sourceMappingURL=index.js.map